import { render } from "./SendCalculationStepContent.vue?vue&type=template&id=fa784de2"
import script from "./SendCalculationStepContent.vue?vue&type=script&lang=js"
export * from "./SendCalculationStepContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__